import { all } from 'redux-saga/effects';
import authWatchers from './auth/saga';
import locationWatchers from './location/saga';

export default function* rootSaga() {
  yield all([...authWatchers, ...locationWatchers]);
}
